import merge from 'lodash/merge';
import startCase from 'lodash/startCase';

import generateTitle from '@glass/common/modules/content/staticVariations/generateTitle';
import getResumeExperienceTitle from '@glass/common/modules/resumes/getResumeExperienceTitle';
import { SPACE_STRING } from '@glass/common/modules/strings/constants';
import { SUPPORT_EMAIL } from '@glass/common/modules/support/rock';
import {
  CITY_FIELD_V2,
  CONTACT_FIELD_V2,
  EMAIL_FIELD_V2,
  FIRST_NAME_FIELD_V2,
  LAST_NAME_FIELD_V2,
  LOCATION_FIELD_V2,
  RESUME_V2_FIELD,
} from '@glass/web/modules/resumes/fieldKeys';

interface CreateBrandResumeProps {
  jSlug?: string;
  iSlug?: string;
}

const createBrandResume =
  ({ jSlug, iSlug }: CreateBrandResumeProps) =>
  (resume: Record<string, any>) => {
    if (!resume) {
      return undefined;
    }

    const slug = jSlug || iSlug;

    const name = getResumeExperienceTitle(resume) || startCase(slug);
    const title = generateTitle({
      name,
      postFixes: ['Resume'],
      maxLength: 27,
      postFixStart: 0,
    });
    if (title) {
      const nameParts = title.split(SPACE_STRING);
      const lastName = nameParts.pop();
      const firstName = nameParts.join(SPACE_STRING);

      merge(resume, {
        [RESUME_V2_FIELD]: {
          [CONTACT_FIELD_V2]: {
            [FIRST_NAME_FIELD_V2]: firstName,
            [LAST_NAME_FIELD_V2]: lastName,
            [EMAIL_FIELD_V2]: SUPPORT_EMAIL,
            [LOCATION_FIELD_V2]: {
              [CITY_FIELD_V2]: process.env.NEXT_PUBLIC_BRAND_TITLE,
            },
          },
        },
      });
    }

    return resume;
  };

export default createBrandResume;
